module.exports = __webpack_public_path__ + "static/media/firstfloorwide.bd307f29.png";